import script from "./MyOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyOrder.vue?vue&type=script&setup=true&lang=ts"

import "./MyOrder.vue?vue&type=style&index=0&id=0ab2dc7d&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab2dc7d"]])

export default __exports__